


















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth, parseISO, format } from "date-fns";
import { Circle2 } from "vue-loading-spinner";
import * as FileDownload from 'js-file-download';
const fileDownload: Function = FileDownload as any;

import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";
import ModalTabs from "@/layouts/DashboardLayoutComponents/ModalTabs.vue";
import { NewActivityCheck } from "@/layouts/DashboardLayoutComponents/new_activity.interface";

import shiftModel from "@/models/shift.model";
import bankingAccountModel from '@/models/bankingAccount.model';
import { showExpandableToast } from '@/utils/error';

@Component({
	components: {
		PaginatedSearch,
		FormField,
		ShiftFilter,
		Circle2,
		ModalTabs,
	},
})
export default class Payroll extends Vue implements NewActivityCheck {
	shiftModel: any;

	payroll: any = [];
	payrollFilter: any;
	loading = false;
	bankingAccountsOptions: any[] = [];
	selectedBankingAccount = null;
	paymentMode: 'NET' | 'GROSS' = 'GROSS';

	async beforeMount() {
		const bankingAccounts = await bankingAccountModel.getBankingAccounts();

		this.bankingAccountsOptions = bankingAccounts.map(account => {
			return {
				name: `${account.name} c/c ${account.accountNumber}-${account.accountDigit}`,
				value: account.id,
			}
		});
	}

	async updateFilter(filter: any) {
		this.selectedProfessionalUserIds = [];
		this.payrollFilter = filter;
		this.loading = true;
		try {
			this.payroll = await shiftModel.getPayroll({ ...filter, lumpSumPayment: true });
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao carregar. Verifique sua conexão com a Internet.");
		}
		this.loading = false;
	}

	showShifts = false;
	shifts: any = [];
	shiftsLoading: boolean = false;
	selectedPayrollRow: any = null;

	async loadShifts(payrollRow: any) {
		this.selectedPayrollRow = payrollRow;
		this.showShifts = true;
		this.shiftsLoading = true;
		try {
			this.shifts = await shiftModel.getPayroll({ ...this.payrollFilter, professionalUser: payrollRow.professionalUserId, detailed: true, lumpSumPayment: true });
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao carregar plantões. Tente novamente.");
		}
		this.shiftsLoading = false;
	}

	bankingFileLoading = false;
	async generateBankingFile() {
		if (!this.selectedBankingAccount) {
			return this.$toasted.error("Selecione uma conta bancária!");
		}

		this.bankingFileLoading = true;
		try {
			const { id, createdDate, cnab } = await shiftModel.generateBankingFile({ ...this.payrollFilter, lumpSumPayment: true }, this.selectedProfessionalUserIds, (this.selectedBankingAccount as any), this.paymentMode);
			const fileName = `SANTANDER_${id}_${format(parseISO(createdDate), 'yyMMddHHmmss')}.rem`;
			fileDownload(cnab, fileName);
			await this.updateFilter(this.payrollFilter);
			if (this.showShifts && this.selectedPayrollRow) {
				await this.loadShifts(this.selectedPayrollRow);
			}
		} catch (error) {
			console.error(error);
			showExpandableToast(this.$toasted, error, "Erro ao gerar arquivo bancário. Tente novamente.");
		}
		this.bankingFileLoading = false;
	}

	selectedProfessionalUserIds: number[] = [];
	rowSelected(payrollItems: any) {
		this.selectedProfessionalUserIds = payrollItems.map((payrollItem: any) => payrollItem.professionalUserId);
	}

	async hasNewActivity(): Promise<boolean> {
		const payroll = await shiftModel.getPayroll({ lumpSumPayment: true, state: 'COMPLETED' });
		return !!payroll.length;
	}
}
